export interface PhoneCountry {
  countryCode?: string;
}

// Normalises PH mobile numbers to the same shape the legacy wizard stored,
// so we don't regress the value format the backend already accepts.
export function normalizeMobileNumber(
  value: string,
  country?: PhoneCountry
): string {
  if (country?.countryCode !== "ph") return value;
  const compact = value.replace(/[^\d+]/g, "");
  if (/^\+630/.test(compact)) return compact.replace(/^\+630/, "+63");
  if (/^\+63/.test(compact)) return compact;
  if (/^09/.test(compact)) return compact.replace(/^0/, "+63");
  if (/^630/.test(compact)) return compact.replace(/^630/, "+63");
  if (/^63/.test(compact)) return `+${compact}`;
  return compact;
}

export function isValidPhMobileNumber(value: string | undefined): boolean {
  return /^\+639\d{9}$/.test(
    normalizeMobileNumber(value || "", { countryCode: "ph" })
  );
}
